import colors from '../../colors.js';

const lightBorder = '1px solid rgba(255,255,255,0.2)';
const darkBorder = '1px solid rgba(0,0,0,0.18)';
const depthBorder = {
  borderTop: darkBorder,
  borderLeft: darkBorder,
  borderBottom: lightBorder,
  borderRight: lightBorder,
};
const depthBorderAlt = {
  borderTop: lightBorder,
  borderLeft: lightBorder,
  borderBottom: darkBorder,
  borderRight: darkBorder,
};
export default {
  container: {
    position: 'relative',
    width: '48px',
    height: '22px',
    borderRadius: '250px',
    outline: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'table',
    clear: 'both',
    content: '',
    cursor: 'pointer',
    boxShadow: 'inset 1px 1px 2px rgba(0,0,0,0.14), inset 0 -1px 3px rgba(255,255,255,0.34)',
    transition: '.25s',
    ...depthBorder,
  },
  containerOn: {
    // background: '#2C81D2',
    // background: colors.highlight,
    background: colors.xdHighlight,
  },
  containerOff: {
    background: '#4d565d',
  },
  switch: {
    display: 'block',
    background: 'linear-gradient(to bottom right, #fff, #efefef)',
    borderRadius: '250px',
    width: '18px',
    height: '18px',
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 'auto',
    transform: 'translateY(-50%)',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    transition: 'left .14s ease-out',
    ...depthBorderAlt,
  },
  switchOn: {
    background: '#fff',
  },
  switchOff: {
    background: '#eaebee',
  },
};
